var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup2176(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.867,
    height: 24.883,
    viewBox: "0 0 24.867 24.883",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2176",
    "data-name": "Group 2176",
    transform: "translate(660.771 -87.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4395",
    "data-name": "Path 4395",
    d: "M-648.326,111.966q-4.872,0-9.745,0a2.64,2.64,0,0,1-2.575-1.837,3.144,3.144,0,0,1,.27-2.381l7.08-14.029q1.293-2.562,2.583-5.124a2.62,2.62,0,0,1,3.844-1.038,3.566,3.566,0,0,1,1.03,1.312q3.651,7.234,7.3,14.467c.753,1.492,1.518,2.979,2.256,4.479a2.9,2.9,0,0,1,.036,2.783,2.539,2.539,0,0,1-2.365,1.365C-641.847,111.975-645.086,111.966-648.326,111.966Zm-.038-1.656h9.535c.1,0,.19,0,.285,0a.963.963,0,0,0,.951-1.177,2.524,2.524,0,0,0-.235-.7q-3.916-7.778-7.843-15.551-.891-1.765-1.78-3.532a.935.935,0,0,0-.87-.587.958.958,0,0,0-.887.568c-.052.1-.106.2-.156.3l-4.59,9.089q-2.458,4.868-4.911,9.738a2.371,2.371,0,0,0-.227.681A.992.992,0,0,0-658,110.308Q-653.184,110.312-648.365,110.309Z",
    transform: "translate(0 0)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4396",
    "data-name": "Path 4396",
    d: "M-436.693,254.852q0-1.412,0-2.824a.834.834,0,0,1,.828-.9.837.837,0,0,1,.828.9q0,2.824,0,5.649a.839.839,0,0,1-.818.911.836.836,0,0,1-.839-.913Q-436.694,256.264-436.693,254.852Z",
    transform: "translate(-212.461 -155.539)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4397",
    "data-name": "Path 4397",
    d: "M-443.441,433.1a1.232,1.232,0,0,1-1.24-1.228,1.239,1.239,0,0,1,1.246-1.25,1.24,1.24,0,0,1,1.24,1.231A1.232,1.232,0,0,1-443.441,433.1Z",
    transform: "translate(-204.889 -325.726)",
    fill: "#4c5b71"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2176);
export default __webpack_public_path__ + "static/media/Group 2176.0fda86de4c44a8757ef078437911376a.svg";
export { ForwardRef as ReactComponent };